<template>
    <div class="card border-0 card-with-shadow mb-primary">
        <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
            <h5 v-show="isDetailsEditable" class="card-title text-muted mb-0">{{ $t('organization_info') }}</h5>
            <h5 v-show="!isDetailsEditable" class="card-title text-muted mb-0">{{$t('change_organization')}}</h5>
            <div>
                <a href="#" v-show="!isDetailsEditable" class="text-muted" @click.prevent="showDetailsHide">
                    <app-icon stroke-width="1" name="x-square"/>
                </a>
                <a href="#" v-show="!isDetailsEditable" class="text-muted" @click.prevent="dealOrganizationUpdate">
                    <app-icon stroke-width="1" name="check-square"/>
                </a>
                <a href="#" v-if="dealStatus" v-show="isDetailsEditable" class="text-muted" @click.prevent="showDetailsEditable">
                    <app-icon stroke-width="1" name="edit"/>
                </a>
            </div>
        </div>
        <div class="card-body">
            <div v-show="isDetailsEditable">
                <template v-if="organizationinfo.organization_id !=null">
                    <div class="form-group">
                        <div class="form-row">
                            <label class="mb-0 text-muted col-3 d-flex align-items-center">
                                {{ $t('name') }}
                            </label>
                            <div class="col-9" v-if="organizationinfo.organization">
                                {{organizationinfo.organization.name}}
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="form-row">
                            <label class="mb-0 text-muted col-3 d-flex align-items-center">
                                {{ $t('type') }}
                            </label>
                            <div class="col-9" v-if="organizationinfo.organization">
                                <app-badge :label="organizationinfo.organization.contact_type.name"
                                           :className="`badge-sm badge-pill badge-${organizationinfo.organization.contact_type.class}`"/>
                            </div>
                        </div>
                    </div>
                    <div class="form-group mb-0">
                        <div class="form-row">
                            <label class="mb-0 text-muted col-3 d-flex align-items-center">
                                {{ $t('owner') }}
                            </label>
                            <div class="col-9" v-if="organizationinfo.owner">
                                <div class="d-flex align-items-center">
                                    <app-avatar
                                        :title="organizationinfo.owner.full_name"
                                        class="mr-2"
                                        :avatar-class="'avatars-w-30'"
                                        :img="organizationinfo.owner.profile_picture ?
                                            organizationinfo.owner.profile_picture.path :
                                            organizationinfo.owner.profile_picture"/>

                                    <span>{{organizationinfo.owner.full_name}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <p class="text-muted">{{ $t('no_organization_linked_yet') }}</p>
                    <a href="#" class="font-size-80" @click.prevent="showDetailsEditable">
                        {{ $t('link_organization_with_the_deal') }}
                    </a>
                </template>
            </div>
            <div v-show="!isDetailsEditable">
                <form ref="form">
                    <div class="form-group">
                        <div class="form-row align-items-center">
                            <div class="col-11">
                                <app-input type="select"
                                           :placeholder="$t('choose_one')"
                                           list-value-field='name'
                                           :list="organizationList"
                                           v-model="organizationinfo.organization_id"/>
                            </div>
                            <div class="col-1">
                                <a href="#" class="text-muted" @click.prevent="deleteOrganization(organizationinfo.id)">
                                    <app-icon width="20" stroke-width="1" name="trash"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    </div>
</template>

<script>
    import {FormMixin} from "@core/mixins/form/FormMixin.js";

    export default {
        name: "DealOrganizationInfo",
        props: ['organizationinfo', 'ownerList'],
        mixins: [FormMixin],
        data() {
            return {
                isDetailsEditable: true,
                formData: {},
            }
        },
        computed: {
            organizationList() {
                return this.$store.getters.getOrganization
            },
            dealStatus() {
                return (this.organizationinfo.status.name == 'status_open' && this.organizationinfo.status.type == 'deal');
            }

        },
        methods: {
            showDetailsHide() {
                this.isDetailsEditable = true;
            },
            showDetailsEditable() {
                this.isDetailsEditable = false;
            },
            dealOrganizationUpdate() {
                this.formData.organization_id = this.organizationinfo.organization_id;
                this.formData.title = this.organizationinfo.title;
                this.submitFromFixin('PATCH', `crm/deals/${this.organizationinfo.id}`, this.formData)
            },

            deleteOrganization(id) {
                this.axiosDelete(`crm/deal/organization/delete/${id}`).then(response => {
                    this.afterSuccess(response);
                }).catch(({error}) => {
                });
            },
            afterSuccess(response) {
                this.$toastr.s(response.data.message);
                this.isDetailsEditable = true
                this.$emit('update-deal')
            }

        },
        mounted() {
            this.$store.dispatch('getOrganization');
        }
    }
</script>

<style scoped>

</style>
